exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content {\n  margin-top: 42px;\n  padding: 10px 30px; }\n\n@media (max-width: 768px) {\n  .content {\n    margin-top: 62px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/help/help.scss
// module id = 1485
// module chunks = 0